<template>
  <div>
    <ProgressTracker></ProgressTracker>
    <section class="section has-text-centered" v-if="oldIE !== -1">
      <div class="container">
        <h1 class="title is-size-1">
          You have a very old version of Internet Explorer.
        </h1>
        <h2 class="title is-size-2">
          Unfortunately, that means this survey won't function properly for you.
          Please upgrade your browser to use this survey form.
        </h2>
      </div>
    </section>
    <div class="container" v-else-if="notExpired">
      <Intro></Intro>
      <Rules></Rules>
      <hr>
      <form id="survey" class="form">
        <AboutYou></AboutYou>
        <hr>
        <Nomination></Nomination>
        <WriteIn></WriteIn>
        <hr>
        <Signature></Signature>
        <Submit></Submit>
      </form>
    </div>
    <section id="expired" class="section has-text-centered" v-else>
      <div class="container">
        <h1 class="title is-size-1">
          Voting has expired!
        </h1>
      </div>
    </section>
  </div>
</template>

<script>
import Intro from '@/components/Intro.vue';
import Rules from '@/components/Rules.vue';
import AboutYou from '@/components/AboutYou.vue';
import Nomination from '@/components/Nomination.vue';
import Signature from '@/components/Signature.vue';
import Submit from '@/components/Submit.vue';
import WriteIn from '@/components/WriteIn.vue';
import ProgressTracker from '@/components/ProgressTracker.vue';

export default {
  components: {
    Intro,
    Rules,
    AboutYou,
    Nomination,
    Signature,
    Submit,
    WriteIn,
    ProgressTracker,
  },
  computed: {
    notExpired() {
      return new Date() < new Date(this.$store.state.expiration_date);
    },
    oldIE() {
      if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        return new Number(RegExp.$1); /* eslint-disable-line */
      }
      return -1;
    },
  },
  mounted() {
    this.$store.dispatch('createUuid');
  },
};
</script>
